import { useSelector } from 'react-redux';
import Globals from '../../store/global-selectors';

export const useShipFrom = (shipFromId) => {
  return useSelector((state) => Globals.selectSellerShipFromsById(state, { shipFromId }));
};
